module.exports = new __parcel__URL__("icon-bbb.b12f253a.png").toString();